exports = module.exports = require("../../../../../../develop/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".break-word[data-v-675baa3a]{overflow-wrap:break-word;word-break:break-all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/css-loader?minimize!/Users/gtirby/develop/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-675baa3a","scoped":true,"hasInlineConfig":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ContragentForm.vue
// module id = 370
// module chunks = 0